/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import DeleteModal from '../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  Separator,
} from 'react-simple-wysiwyg';
import Select from 'react-select';

const DocumentTemplateView = () => {
  const token = getAuthToken();

  const [data, setData] = useState({ items: [] });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [modalRole, setModalRole] = useState(false);
  const [roleFormData, setRoleFormData] = useState({
    name: null,
    template: null,
    clausaType: null,
    id: null,
  });

  const [clauseTypeData, setClauseTypeData] = useState({ items: [] });
  const [filterText, setFilterText] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const handleDeleteModal = id => {
    const selectedRow = data.items.find(item => item.id === id);
    setInvoice(selectedRow);
    setDeleteModal(true);
  };

  const handleDeleteInvoice = async () => {
    if (invoice) {
      try {
        const response = await fetch(
          `${api.API_URL}/template-procurement-document/${invoice.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        toast.success('Document Template berhasil dihapus!', {
          autoClose: 3000,
        });
        setDeleteModal(false);
        setInvoice(null);
        fetchData(currentPage, rowsPerPage, token);
      } catch (err) {
        toast.error(`Gagal menghapus role: ${err.message}`, {
          autoClose: 3000,
        });
      }
    }
  };

  const deleteMultiple = () => {
    // Implement multiple delete functionality
    // This would typically involve deleting selected items
    // For now, just close the modal
    setDeleteModalMulti(false);
  };

  const toggleRoleModal = () => {
    setModal(!modal);
  };

  const columns = [
    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          name{' '}
        </span>
      ),
      selector: row => row.name,
      sortable: true,
      width: '40%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.name}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Clause{' '}
        </span>
      ),
      selector: row => row.clauseDetail?.clauseTitle,
      sortable: true,
      width: '50%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.clauseDetail?.clauseTitle || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '10%',
      sortable: false,
      className: 'text-end',
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleUpdateModal(row.id)}
          >
            <i className='ri-pencil-fill align-bottom'></i>
          </button>
          <button
            className='btn btn-soft-danger btn-sm btn-icon'
            onClick={() => handleDeleteModal(row.id)}
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </button>
        </div>
      ),
    },
  ];

  document.title = 'Data Document Template';

  const handleChange = e => {
    const { name, value } = e.target;
    setRoleFormData({ ...roleFormData, [name]: value });
  };

  const handleNoteTextChange = (event, field) => {
    setRoleFormData(prev => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage, token);
    fetchClauseType();
  }, [currentPage, rowsPerPage, token]);

  // Filter data based on search text
  useEffect(() => {
    if (filterText) {
      const filtered = data.items.filter(
        item =>
          item.id?.toLowerCase().includes(filterText.toLowerCase()) ||
          item.name?.toLowerCase().includes(filterText.toLowerCase()) ||
          item.template?.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data.items);
    }
  }, [data.items, filterText]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
  };

  const clearFilter = () => {
    setFilterText('');
  };

  const fetchData = async (currentPage, rowsPerPage, token) => {
    fetch(
      `${api.API_URL}/template-procurement-document?PageNumber=${currentPage}&PageSize=${rowsPerPage}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      }
    )
      .then(data => data.json())
      .then(
        result => {
          setData({
            items: result.data.items || [],
          });
          setTotalRows(result.data.totalItems || 0);
        },
        _error => {
          // Handle error appropriately
        }
      )
      .catch(_error => {
        // Handle error silently or show appropriate message
      });
  };

  const fetchClauseType = async () => {
    try {
      const response = await fetch(
        `${api.API_URL}/clause-detail?PageNumber=1&PageSize=100`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = (result.data?.items || []).map(item => ({
        value: item.id,
        label: item.clauseTitle,
      }));
      setClauseTypeData({ items });
    } catch (error) {
      console.error('Error fetching clause type:', error);
    }
  };

  const handlePageChange = useCallback(page => {
    setCurrentPage(page);
  }, []);

  const handlePerRowsChange = useCallback(newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  }, []);

  const handleNewModal = () => {
    setRoleFormData({
      name: null,
      template: null,
      clausaType: null,
      id: null,
    });
    roleModal();
  };

  const handleUpdateModal = async (mid = null) => {
    await fetchRoleDetail(mid);
    roleModal();
  };

  const roleModal = () => {
    setModalRole(!modalRole);
  };

  const selectedFieldsRole = {
    name: roleFormData.name,
    template: roleFormData.template,
    clauseDetailId: roleFormData.clausaType,
  };

  const handleAddDataRole = async () => {
    try {
      await axios.post(
        `${api.API_URL}/template-procurement-document`,
        selectedFieldsRole,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Document Template Has been Added`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token);
    }
  };

  const fetchRoleDetail = async mid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/template-procurement-document/${mid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response;
      setRoleFormData({
        name: data.name || null,
        template: data.template || null,
        clausaType: data.clauseDetailId || null,
        id: data.id || null,
      });
    } catch (error) {
      // Handle error silently or show appropriate message
    }
  };

  const handleUpdDataRole = async mid => {
    try {
      await axios.put(
        `${api.API_URL}/template-procurement-document/${mid}`,
        selectedFieldsRole,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
      console.log('hasil', selectedFieldsRole);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token);
    }
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => handleDeleteInvoice()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='Document Template' />

          <Row>
            <Col lg={12}>
              <Card id='HazardList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      Data Document Template
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => handleNewModal()}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New Document Template
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div className='d-flex justify-content-between align-items-center mt-3'>
                    <div className='d-flex align-items-center gap-2'>
                      <Input
                        type='text'
                        placeholder='Search Document Template...'
                        value={filterText}
                        onChange={handleFilterChange}
                        style={{ width: '300px' }}
                        className='form-control-sm'
                      />
                      {filterText && (
                        <Button
                          color='secondary'
                          size='lg'
                          onClick={clearFilter}
                          outline
                        >
                          <i className='ri-close-line'></i> Clear
                        </Button>
                      )}
                    </div>
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  <div className='table-responsive'>
                    <DataTable
                      columns={columns}
                      highlightOnHover
                      data={filteredData}
                      pagination
                      paginationServer={!filterText}
                      paginationTotalRows={
                        filterText ? filteredData.length : totalRows
                      }
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      showPaginationBottom={true}
                      wrap
                      dense
                      striped
                      noDataComponent={
                        <div className='text-center py-4'>
                          <div className='mb-3'>
                            <i className='ri-search-line fs-2 text-muted'></i>
                          </div>
                          <h5 className='mt-2'>No data found</h5>
                        </div>
                      }
                      defaultSortFieldId={1}
                      defaultSortAsc={true}
                      customStyles={{
                        header: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontWeight: 'bold',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f8f9fa',
                            fontWeight: '600',
                            fontSize: '13px',
                            color: '#495057',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflow: 'visible',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '50px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        table: {
                          style: {
                            tableLayout: 'auto',
                            width: '100%',
                          },
                        },
                        responsiveWrapper: {
                          style: {
                            minHeight: '200px',
                            overflowX: 'hidden',
                          },
                        },
                      }}
                    />

                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            isOpen={modalRole}
            role='dialog'
            autoFocus={true}
            centered
            id='addAddressModal'
            toggle={toggleRoleModal}
            data-bs-backdrop='static'
            size='xl'
          >
            <ModalHeader
              className='bg-soft-info'
              toggle={() => {
                setModalRole(!modalRole);
              }}
            >
              <span className='modal-title text-info fw-bold'>
                {roleFormData.id !== null
                  ? 'Edit Document Template'
                  : 'Add Document Template'}
              </span>
            </ModalHeader>

            <ModalBody>
              <div className='d-flex mt-2'>
                <Col sm={12}>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-1'>
                        <Label for='role-name-2' className='form-label '>
                          Document Template Name :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='text'
                            id='name'
                            name='name'
                            className='form-control'
                            value={roleFormData.name || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                name: '',
                              });
                            }}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label for='clausaType' className='form-label'>
                          Clausa Type :
                        </Label>
                        <Select
                          name='clausaType'
                          id='clausaType'
                          options={clauseTypeData.items}
                          placeholder='Please Select'
                          value={
                            clauseTypeData.items?.find(
                              obj => obj.value === roleFormData.clausaType
                            ) || null
                          }
                          onChange={e => {
                            setRoleFormData({
                              ...roleFormData,
                              clausaType: e ? e.value : null,
                            });
                            setErrors({
                              ...errors,
                              clausaType: '',
                            });
                          }}
                          styles={{
                            singleValue: base => ({
                              ...base,
                              color: '#000',
                            }),
                            input: base => ({
                              ...base,
                              color: '#000',
                            }),
                          }}
                        />
                      </div>
                    </Col>

                    <Col sm={12}>
                      <div className='mb-2'>
                        <Label className='form-label text-uppercase fw-semibold'>
                          template
                        </Label>
                      </div>
                      <div className='snow-editor'>
                        <EditorProvider>
                          <Editor
                            id='template'
                            name='template'
                            value={roleFormData.template || ''}
                            onChange={e => {
                              handleNoteTextChange(e, 'template');
                              setErrors(prev => ({
                                ...prev,
                                template: '',
                              }));
                            }}
                            style={{
                              height: '500px',
                              overflowY: 'auto',
                              whiteSpace: 'normal',
                              overflowWrap: 'break-word',
                              wordBreak: 'break-word',
                            }}
                            className='form-control'
                          >
                            <Toolbar>
                              <BtnBold />
                              <BtnItalic />
                              <BtnBulletList />
                              <BtnClearFormatting />
                              <BtnLink />
                              <BtnNumberedList />
                              <BtnRedo />
                              <BtnStrikeThrough />
                              <BtnStyles />
                              <BtnUnderline />
                              <BtnUndo />
                              <Separator />
                            </Toolbar>
                          </Editor>
                        </EditorProvider>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                color='danger'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalRole(!modalRole);
                }}
              >
                {' '}
                <i className=' ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
                Close
              </Button>
              <Button
                color='primary'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalRole(!modalRole);
                  roleFormData.id !== null
                    ? handleUpdDataRole(roleFormData.id)
                    : handleAddDataRole();
                }}
              >
                {' '}
                <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                {roleFormData.id !== null ? 'Update' : 'Save'}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DocumentTemplateView;
